
import React, { Component } from 'react'

import { connect } from 'react-redux'
import CONSTANTS from './constants'
//import { hotjar } from 'react-hotjar'
import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
import { withRouter } from 'react-router'

import {
  CurrentStepSetAction,
  dealerSetAction,
  bookingSetAction,
  setVeiculeInfos,
  setVeiculeKilo,
  setServices,
  setUploadFiles,
  setCustomerAttachmentId,
  setEditMode,
  selectedServices,
  setCommentServices,
  setPersonalInformations,
  setSelectedPremiumServicesToStore,
  setListPremiumServicesToStore,
  setFilterDealersBy,
  setIdRdvLeads
} from './actions/action'

import PageMapSolo from './components/page-map-solo/pagemapsolo'
import PageMap from './components/page-map/pagemap'
import PageNoMap from './components/page-nomap/pagenomap'
import PageSolo from './components/page-map-solo/pagesolo'
import NotFoundPage from './components/NotFoundPage/NotFoundPage'
import MaintenancePage from './components/MaintenancePage/MaintenancePage'
import HomePage from './components/HomePage/homePage'
import HomePageMap from './components/HomePage/homePageWithMap'
import VosBesoins from './components/VosBesoins/vosBesoins'
import MyInfos from './components/MyInfosPage/myInfos'
import SummaryPage from './components/SummaryPage/summaryPage'
import CarDetails from './components/CarDetails/CarDetails'
import ConfirmationPage from './components/ConfirmationPage/confirmationPage'
import { slugify } from './helpers/functions'
import Layout from './layouts/Layout'
import LayoutWithRecap from './layouts/LayoutWithRecap'
import 'babel-polyfill'

import './styles.css'

const mapStateToProps = state => state
const mapDispatchToProps = {
  CurrentStepSetAction,
  dealerSetAction,
  bookingSetAction,
  setVeiculeInfos,
  setVeiculeKilo,
  setCustomerAttachmentId,
  setUploadFiles,
  setServices,
  setEditMode,
  selectedServices,
  setCommentServices,
  setPersonalInformations,
  setSelectedPremiumServicesToStore,
  setListPremiumServicesToStore,
  setFilterDealersBy,
  setIdRdvLeads
}

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dealerId: 0
    }

    if (window.location.href.toUpperCase().includes('BOOKING.ASPX') ||
      window.location.href.toUpperCase().endsWith(CONSTANTS.SITE_ROUTS.HOMEPAGE.toUpperCase()) ||
      window.location.href.toUpperCase().includes(CONSTANTS.SITE_ROUTS.HOMEPAGE.toUpperCase() + '?')
    ) {
      this.props.dealerSetAction({})
      this.props.bookingSetAction({})
      this.props.setVeiculeInfos({})
      this.props.setVeiculeKilo({})
      this.props.setServices([])
      this.props.selectedServices([])
      this.props.setCustomerAttachmentId("")
      this.props.setUploadFiles([])
      this.props.setCommentServices("");
      this.props.setSelectedPremiumServicesToStore([])
      this.props.setListPremiumServicesToStore([])
      this.props.setFilterDealersBy([])
      this.props.setPersonalInformations({})
      this.props.CurrentStepSetAction(1);
      this.props.setEditMode(false)
      this.props.setIdRdvLeads(0);

      if (window.siteConfig.existData == 1) {
        this.props.setIdRdvLeads(window.siteConfig.idRdvLeads);
        this.props.setVeiculeInfos({
          "SerialNumber": window.siteConfig.userVehicleInfos.vin,
          "Mileage": window.siteConfig.userVehicleInfos.km
        })
        this.props.setPersonalInformations({
          "civilityCode": window.siteConfig.userInfos.civility,
          "firstname": window.siteConfig.userInfos.firstname,
          "name": window.siteConfig.userInfos.lastname,
          "mail": window.siteConfig.userInfos.email,
          "phone": window.siteConfig.userInfos.phone
        })
      }
      else {
        this.props.setVeiculeInfos({
          "SerialNumber": "",
          "Mileage": ""
        })
        this.props.setPersonalInformations({
          "civilityCode": "",
          "firstname": "",
          "name": "",
          "mail": "",
          "phone": ""
        })
      }

    }
    sessionStorage.setItem("afficherPdvTest", window.siteConfig.afficherPdvTest)
    sessionStorage.setItem("tmtsInterventionIds", window.siteConfig.interventionIds)
    sessionStorage.setItem("origine", window.siteConfig.origine)
  }

  componentWillMount() {
    if (this.props.location.pathname.indexOf('booking.aspx') > -1 && this.props.location.hash.indexOf('dealer') > -1) {
      this.setState({ dealerId: this.props.location.hash.split('/').pop() })
    }

  }
  componentDidMount() {
    const { history } = this.props;
    // const hjid = (window.siteConfig.currentBrand == 'P' ? 509716 : (window.siteConfig.currentBrand == 'C' ? 812040 : (window.siteConfig.currentBrand == 'D' ? 813442 : 509716)))
    // hotjar.initialize(hjid, 6);

    history.listen((newLocation, action) => {
      if (action === "PUSH") {
        if (newLocation.pathname !== this.currentPathname || newLocation.search !== this.currentSearch) {
          // Save new location 
          this.currentPathname = newLocation.pathname;
          this.currentSearch = newLocation.search;


          // Clone location object and push it to history 
          history.push({
            pathname: newLocation.pathname,
            search: newLocation.search
          });
        }
      } else {
        // Send user back if they try to navigate back 
        //history.go(1); 
      }
    });


  }


  render() {
    const { step } = this.props.store || ''
    const { geoID, city, name } = this.props.store.dealer || ''
    const steps = [CONSTANTS.SITE_ROUTS.HOMEPAGE,
    CONSTANTS.SITE_ROUTS.SOLODEALERPAGE + (city ? slugify(city) : '404') + '/' + (name ? slugify(name) : 'garage-psa') + '/' + geoID,
    CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE,
    CONSTANTS.SITE_ROUTS.SERVICESPAGE,
    CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE,
    CONSTANTS.SITE_ROUTS.SUMMARYPAGE]
    const currentStepName = steps[step - 1]

    return (
      <>

        <Switch>

          <Route
            exact path={CONSTANTS.SITE_ROUTS.HOMEPAGE}
            render={() => (
              <>

                {(!this.props.store.isEditMode
                  ? (
                    window.siteConfig.ActivateHomepageMap == true
                      ? <Layout>    <HomePageMap />  </Layout>
                      : <Layout> <HomePage /> </Layout>
                  )
                  : <Switch>
                    <Redirect
                      key='redirect-from-home-page'
                      push
                      to={{ pathname: steps[2] }}
                    />
                  </Switch>
                )}
              </>
            )}
          />
          <Route
            exact path={CONSTANTS.SITE_ROUTS.CONFIRMATION} render={() => (

              (step > 5 ? <Layout BreadcrumbIsEnabled={CONSTANTS.SITE_INFO.BRAND_CODE === 'V' ? true : false}> <ConfirmationPage />  </Layout>
                : <Switch>
                  <Redirect
                    key='from-list'
                    push
                    to={{ pathname: currentStepName }}
                  />
                </Switch>)

            )}
          />

          <Route
            exact path={CONSTANTS.SITE_ROUTS.SERVICESPAGE} render={() => (
              // if in production just redirect to the last step
              // where the user is filled the informations
              // DEV ENVIREMENT : dont waste time on passing throught the prossess
              // test only.
              (process.env.NODE_ENV !== 'production'
                ? <Layout> <LayoutWithRecap>  <VosBesoins /> </LayoutWithRecap> </Layout>
                : (step == 4 ? <Layout>  <LayoutWithRecap><VosBesoins /></LayoutWithRecap>  </Layout> : <Switch>
                  <Redirect
                    key='from-list'
                    push
                    to={{ pathname: currentStepName }}
                  />
                </Switch>)
              )

            )}
          />

          <Route
            exact path={CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE} render={() => (
              // if in production just redirect to the last step
              // where the user is filled the informations
              // DEV ENVIREMENT : dont waste time on passing throught the prossess
              // test only.
              <>
                {(process.env.NODE_ENV !== 'production'
                  ? (step == 3 ? <Layout>
                    <LayoutWithRecap>
                      <CarDetails />
                    </LayoutWithRecap>
                  </Layout>
                    : <Layout>
                      <Switch>
                        <Redirect
                          key='from-page-car'
                          push
                          to={{ pathname: currentStepName }}
                        />
                      </Switch>
                    </Layout>
                  )
                  : (step == 3 ? <Layout>
                    <LayoutWithRecap>
                      <CarDetails />
                    </LayoutWithRecap>
                  </Layout>
                    : <Layout>
                      <Switch>
                        <Redirect
                          key='from-list'
                          push
                          to={{ pathname: currentStepName }}
                        />
                      </Switch>
                    </Layout>
                  )
                )}
              </>

            )}
          />
          <Route
            exact path={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE} render={() => (
              // if in production just redirect to the last step
              // where the user is filled the informations
              // DEV ENVIREMENT : dont waste time on passing throught the prossess
              // test only.
              <>
                {(process.env.NODE_ENV !== 'production'
                  ? <Layout>  <LayoutWithRecap><MyInfos /></LayoutWithRecap></Layout>
                  : (step == 5 ? <Layout> <LayoutWithRecap><MyInfos /></LayoutWithRecap></Layout> : <Switch>
                    <Redirect
                      key='from-list'
                      push
                      to={{ pathname: currentStepName }}
                    />
                  </Switch>)
                )}
              </>

            )}
          />
          <Route
            exact path={CONSTANTS.SITE_ROUTS.SUMMARYPAGE} render={() => (
              // if in production just redirect to the last step
              // where the user is filled the informations
              // DEV ENVIREMENT : dont waste time on passing throught the prossess
              // test only.
              <>
                {(process.env.NODE_ENV !== 'production'
                  ? <Layout> <SummaryPage /></Layout>
                  : (step == 6 ? <Layout> <SummaryPage /></Layout>
                    : <Switch>
                      <Redirect
                        key='from-list'
                        push
                        to={{ pathname: currentStepName }}
                      />
                    </Switch>)
                )}
              </>

            )}
          />

          <Route
            exact path={`${CONSTANTS.SITE_ROUTS.EDITRDV}/:idBasket/:token`}
            render={() => (

              <Layout>
                <SummaryPage Edit />
              </Layout>
            )}
          />
          <Route
            exact path={`${CONSTANTS.SITE_ROUTS.V2EDITRDV}/:idBasket/:token`}
            render={() => (

              <Layout>
                <SummaryPage Edit />
              </Layout>
            )}
          />

          <Route
            exact path={`${CONSTANTS.SITE_ROUTS.LISTDEALERSPAGE}/:adress`}
            render={() => (
              <>
                {(!this.props.store.isEditMode
                  ? (
                    window.siteConfig.ActivateFocusMap == true
                      ? (step <= 2 ? <Layout> <PageMap /> </Layout>
                        : <Switch>
                          <Redirect
                            key='form-list'
                            push
                            to={{ pathname: currentStepName }}
                          />

                        </Switch>)
                      : <Layout>  <PageNoMap /> </Layout>
                  )
                  : <Switch>
                    <Redirect
                      key='from-list'
                      push
                      to={{ pathname: currentStepName }}
                    />
                  </Switch>
                )}
              </>
            )}
          />

          <Route
            exact path={`${CONSTANTS.SITE_ROUTS.V2LISTDEALERSPAGE}/:adress`}
            render={() => (
              <>
                {(!this.props.store.isEditMode
                  ? (
                    window.siteConfig.ActivateFocusMap == true
                      ? (step <= 2 ? <Layout> <PageMap /> </Layout>
                        : <Switch>
                          <Redirect
                            key='form-list'
                            push
                            to={{ pathname: currentStepName }}
                          />

                        </Switch>)
                      : <Layout>  <PageNoMap /> </Layout>
                  )
                  : <Switch>
                    <Redirect
                      key='from-list'
                      push
                      to={{ pathname: currentStepName }}
                    />
                  </Switch>
                )}
              </>
            )}
          />
          <Route
            path={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}:city?/:dealerName?/:iddealer?`}
            render={() => (
              <>
                {(
                  window.siteConfig.ActivateFocusMap == true
                    ? <Layout> <PageMapSolo />  </Layout>
                    : <Layout> <PageSolo />  </Layout>
                )}
              </>
            )}
          />
          <Route
            path={`${CONSTANTS.SITE_ROUTS.V2SOLODEALERPAGE}:city/:dealerName/:iddealer`}
            render={() => (

              <>
                {(
                  window.siteConfig.ActivateFocusMap == true
                    ? <Layout> <PageMapSolo />  </Layout>
                    : <Layout> <PageSolo />  </Layout>
                )}
              </>

            )}
          />

          <Route
            exact path='/404' render={() => (
              <Layout BreadcrumbIsEnabled={false}>
                <NotFoundPage />
              </Layout>
            )}
          />

          {CONSTANTS.SITE_INFO.BRAND_CODE == "V" && <Route
            exact path='/maintenance' render={() => (
              <Layout BreadcrumbIsEnabled={false}>
                <MaintenancePage />
              </Layout>
            )}
          />}
          <Route
            exact path={CONSTANTS.SITE_ROUTS.V2HOMEPAGE} render={() => (
              <Switch>
                <Redirect
                  push
                  to={{ pathname: String(CONSTANTS.SITE_ROUTS.HOMEPAGE) }}
                />
              </Switch>
            )}
          />
          <Route
            exact path='/booking.aspx' render={() => (
              <Switch>
                <Redirect
                  push
                  to={{ pathname: String(CONSTANTS.SITE_ROUTS.HOMEPAGE) }}
                />
              </Switch>
            )}
          />
          <Route path="/" component={App} />
          <Route path="*" component={NotFoundPage} />
          <Route render={() => (
            <Switch>
              <Redirect
                push
                to={{ pathname: '/404' }}
              />
            </Switch>
          )}
          />
          <Redirect to="/404" />
        </Switch>

        {!!this.state.dealerId && this.props.location.pathname.indexOf('booking.aspx') > -1 && <Switch>
          <Redirect
            push
            to={{ pathname: String(CONSTANTS.SITE_ROUTS.SOLODEALERPAGE + slugify(CONSTANTS.SITE_INFO.CountryName) + '/' + slugify(CONSTANTS.SITE_INFO.DealerName) + '/' + this.state.dealerId) }}
          />
        </Switch>}
      </>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
